import '@popperjs/core';
import 'bootstrap';

window.htmx = require('htmx.org');
